import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {setTicketLabelsMutation, SetTicketLabelsInput} from './__generated__/setTicketLabelsMutation.graphql';

const mutation = graphql`
	mutation setTicketLabelsMutation($input: SetTicketLabelsInput!) {
		setTicketLabels(input: $input) {
			clientMutationId
			ticket {
				id
				labels {
					id
					name
					color
					category {
						name
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: SetTicketLabelsInput,
	onCompleted?: (r: setTicketLabelsMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<setTicketLabelsMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'setTicketLabelsMutation'};
